import React from 'react';
import { components } from 'react-select';

const ValueContainer = ({ children, ...props }: any) => {
  const [values, input] = children as any;
  const { getValue, hasValue, selectProps } = props;
  const nbValues = getValue().length;

  if (!hasValue) {
    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  }

  return (
    <components.ValueContainer {...props}>
      {`${selectProps.selected}: ${nbValues}`}
      {input}
    </components.ValueContainer>
  );
};

export default ValueContainer;
